module.exports = {
      id: "shorts-usage",
      viewBox: "0 0 150 150",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#shorts",
      toString: function () {
        return this.url;
      }
    }